/** basic.collectSite */
export default {
    site_collectTips: "Отменить избранное для объекта?",
    site_cancelCollect: "Убрать из избранного",
    site_rulesLon: "Долгота не может быть пустой",
    site_rulelat: "Широта не может быть пустой",
    stie_cancelSiteSucc: "Объект убран из избранного!",
    site_cancelSiteLose: "Не удалось убрать объект из избранного!",

    basic_deleteImgTips: "Удалить это изображение?",
    basic_UpImgSucc: "Изображение загружено!",
    basic_UpImgLose: "Не удалось загрузить изображение!",
    basic_cancelUp: "Загрузка отменена!",

    map_TiTle: "Информация карты",
    map_editPoint: "Изменить точку",
    map_confirmPoint: "Сохранить",
    map_lon: "Долгота",
    map_lng: "Широта",
    map_siteNamePla: "Введите название объекта для поиска",
    map_tips: "Вы можете перемещать синюю метку в нужное место",
}

